/**
 * @About
 * This file mange environment of the project
 */

export const devSetting = {
  api: {
    url: "http://localhost:5001/healthyplaneat/api/v1/",
    // url: "https://devapi.healtyplanet.tk/healthyplaneat/api/v1/"
  },
}

export const stagSetting = {
  api: {
    url: "https://healthyplaneat-backend-main-fbk8ln.laravel.cloud/api/v1/",
  },
}

export const prodSetting = {
  api: {
    url: "https://api.healthyplaneat.com/healthyplaneat/api/v1/",
  },
}

export const localhostSetting = {
  api: {
    url: "http://localhost:5004/healthyplaneat/api/v1/",
  },
}
